import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { BaseView, BaseText } from '@/components/base'
import { HeaderWithTitleAndDescription } from '@/components/HeaderWithTitleAndDescription'
import { FixedBottomButton } from '@/components/FixedBottomButton'
import { GoalsList } from '@/features/savings/select'
import { useSavingsStore } from '@/store/useSavingsStore'
import useOffsets from '@/hooks/useOffsets'

export default function SelectGoalPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const offsets = useOffsets()

  const selectedGoal = useSavingsStore((state) => state.goal)
  const savedGoalId = useSavingsStore((state) => state.savedGoalId)
  const setSavingGoalId = useSavingsStore((state) => state.setSavingGoalId)

  // Reset savedGoalId only if we came here to create a new goal
  // (when there is no category or savedGoalId)
  React.useEffect(() => {
    if (!selectedGoal.category && !savedGoalId) {
      setSavingGoalId('')
    }
  }, [selectedGoal.category, savedGoalId, setSavingGoalId])

  const handleConfirm = () => {
    if (selectedGoal.category) {
      navigate('/savings/set')
    }
  }

  const isConfirmDisabled = !selectedGoal.category

  return (
    <BaseView
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 20,
        paddingBottom: `${offsets.bottom + 100}px`,
      }}
    >
      {/* Header Navigation with Title and Description */}
      <HeaderWithTitleAndDescription
        title={t('translation:goal.chooseAnEmoji.title')}
        description={t('translation:goal.chooseAnEmoji.description')}
        onBackPress={() => navigate(-1)}
      />

      {/* Content */}
      <BaseView
        style={{
          flex: 1,
          paddingLeft: '13px',
          paddingRight: '13px',
          paddingTop: `${offsets.top + 56 + 24 + 20 + 28 + 20 + 12}px`, // top offset + navigation height + title + gap + description + gap + padding
        }}
      >
        {/* Goals Grid */}
        <GoalsList style={{ flex: 1 }} />
      </BaseView>

      {/* Fixed Bottom Button */}
      <FixedBottomButton
        buttons={{
          label: t('form:actions.confirm', 'Confirm'),
          onPress: handleConfirm,
          disabled: isConfirmDisabled,
          type: 'primaryGradient',
          size: 'large',
        }}
      />
    </BaseView>
  )
}
